<script lang="ts">
	import { onMount } from "svelte";
	import { yyyy, zzzz } from "../../store.svelte";
	import Fa from "svelte-fa";
	import { faChevronDown, faChevronRight } from "@fortawesome/free-solid-svg-icons";

	const url: string = yyyy.uri.api;
	
	// Function to highlight search terms
	function highlightSearchTerm(text: string, searchTerm: string): string {
		if (!searchTerm || !text || typeof text !== 'string') return text;
		
		const regex = new RegExp(`(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
		return text.replace(regex, '<mark class="search-highlight">$1</mark>');
	}

	interface Props {
		lw_id: number;
	}

	let { lw_id }: Props = $props();

	let info = $state([]);
	let expandedStates = $state({});

	function isIterable(variable) {
		return (
			typeof variable === "object" &&
			variable !== null &&
			typeof variable[Symbol.iterator] === "function"
		);
	}
	
	let grabInfo = async (lw_id: number) => {
		let _hdrs = {
			"Content-Type": "application/json",
			Authorization: "Bearer " + yyyy.sesh.logtoken.token,
		};
		let _body = JSON.stringify({
			lw_id: lw_id,
			livewire: yyyy.sesh.activeLivewire.wireident,
		});
		let fetchopts = { method: "post", body: _body, headers: _hdrs };

		const response = await fetch(`${url}/rpc/get_info`, fetchopts);
		if (response.ok) {
			let resp = await response.json();
			console.log(resp);

			let preinfo = Object.keys(resp.originrow).map((key) => ({
				key,
				value: resp.originrow[key],
			}));
			console.log("+", preinfo);
			console.log(typeof preinfo);
			console.log(preinfo.length);
			info = preinfo;
		} else {
			alert("bad");
		}
	};

	const toggleExpand = (key) => {
		expandedStates[key] = !expandedStates[key];
	};

	onMount(() => {
		console.log('info mounted')
		$effect(() => {
			grabInfo(lw_id);
		});
	});
</script>

<dl class="info-details">
	{#each info as item}
		{#if item.value !== null && item.value !== undefined && item.value !== ""}
			<div class="info-property">
				<dt class="property-label">
					{#if typeof item.value === "object" && item.value !== null}
						<button 
							class="expand-toggle"
							onclick={() => toggleExpand(item.key)}
							aria-expanded={expandedStates[item.key] || false}
						>
							<Fa icon={expandedStates[item.key] ? faChevronDown : faChevronRight} size="xs" />
							{item.key}:
						</button>
					{:else}
						{item.key}:
					{/if}
				</dt>
				<dd class="property-value">
					{#if typeof item.value === "object" && item.value !== null}
						{#if expandedStates[item.key]}
							<pre class="json-value">{JSON.stringify(item.value, null, 2)}</pre>
						{:else}
							<span class="json-preview">{JSON.stringify(item.value).substring(0, 50)}...</span>
						{/if}
					{:else if yyyy.ctrl.searchTerm}
						{@html highlightSearchTerm(String(item.value), yyyy.ctrl.searchTerm)}
					{:else}
						{item.value}
					{/if}
				</dd>
			</div>
		{/if}
	{/each}
</dl>

<style>
	/* Main container styling */
	.info-details {
		font-size: 0.9rem;
		margin: 0;
		padding: 0;
	}

	/* Property container */
	.info-property {
		margin-bottom: 0.5rem;
	}

	/* Label styling */
	.property-label {
		color: #363636;
		font-weight: normal;
		margin: 0 0 0.2rem 0;
		padding: 0;
	}

	/* Value styling with indent */
	.property-value {
		color: #4a4a4a;
		margin: 0 0 0 1rem;
		padding: 0;
		word-break: break-word;
	}
	
	/* Search term highlighting */
	:global(.search-highlight) {
		background-color: #ff3e00;
		color: #fff;
		padding: 0.5px 4px;
		border-radius: 4px;
		font-weight: 500;
	}

	/* Expand/collapse button */
	.expand-toggle {
		background: none;
		border: none;
		padding: 0;
		margin: 0;
		color: #363636;
		cursor: pointer;
		display: inline-flex;
		align-items: center;
		gap: 0.3rem;
		font: inherit;
	}

	.expand-toggle:hover {
		color: #ff3e00;
	}

	/* JSON preview (collapsed state) */
	.json-preview {
		color: #7a7a7a;
		font-family: monospace;
		font-size: 0.85rem;
	}

	/* JSON full view (expanded state) */
	.json-value {
		margin: 0.3rem 0 0 0;
		padding: 0.5rem;
		background-color: #f5f5f5;
		border-radius: 4px;
		font-size: 0.8rem;
		overflow-x: auto;
		white-space: pre;
		font-family: monospace;
		border: 1px solid #e5e7eb;
	}

	/* Remove default pre styling */
	pre {
		margin: 0;
		padding: 0;
	}
</style>
